import { __extends } from "tslib";
import { CheckboxIcon } from './checkbox-icon';
import { ErrorMsg } from '../contact-form-utils';
import { CustomFieldType, KeyCode, } from '@wix/answers-api';
import * as React from 'react';
// import * as ReactSelect from 'react-select';
import { NumericInput, DeprecatedSelect } from '@wix/answers-ui-libby';
import { classNames } from '@wix/answers-lib';
import { PublicMultilevelField } from '../../public-multilevel-field';
import { isFeatureEnabled } from '@wix/answers-experiments';
var CustomField = /** @class */ (function (_super) {
    __extends(CustomField, _super);
    function CustomField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tp = function (key, params) {
            if (params === void 0) { params = {}; }
            return _this.props.t("common.contact-form.custom-field." + key, params);
        };
        _this.onValueChange = function (value) { return _this.props.onCustomFieldChange(_this.props.customField.name, value); };
        _this.onTargetValueChange = function (e) { return _this.onValueChange(e.target.value); };
        _this.onCheckboxChange = function (e) { return _this.onValueChange(e.target.checked); };
        _this.onSelectChange = function (option) { return _this.onValueChange(option.value); };
        _this.onNumericChange = function (value) {
            var newValue = value ? value : '';
            _this.onValueChange(newValue);
        };
        _this.onAccessibilityKeyup = function (e) {
            if (e.keyCode === KeyCode.ENTER || e.keyCode === KeyCode.SPACE) {
                var name_1 = ".checkbox-item." + _this.props.customField.name;
                var checkboxElement = document.querySelector(name_1);
                if (checkboxElement) {
                    checkboxElement.click();
                }
            }
        };
        _this.onAccessibilityClick = function () {
            if (document.activeElement && document.activeElement.blur) {
                document.activeElement.blur();
            }
        };
        _this.setCheckboxRef = function (elem) {
            if (elem) {
                _this.checkBoxRef = elem;
                elem.addEventListener('keyup', _this.onAccessibilityKeyup);
                elem.addEventListener('click', _this.onAccessibilityClick);
            }
        };
        return _this;
    }
    CustomField.prototype.componentWillUnmount = function () {
        if (this.checkBoxRef) {
            this.checkBoxRef.removeEventListener('keyup', this.onAccessibilityKeyup);
            this.checkBoxRef.removeEventListener('click', this.onAccessibilityClick);
        }
    };
    CustomField.prototype.render = function () {
        var props = this.props;
        var customField = props.customField;
        var fieldValue = props.fieldValue;
        var fieldData = customField.data || customField.multiLevelData;
        var fieldName = customField.name;
        var fieldType = CustomFieldType[customField.type];
        var showCustomFieldError = props.showError && ((!fieldValue && customField.mandatory) || !!props.validationError);
        var customFieldErrorMsg = (React.createElement(ErrorMsg, { msg: props.validationError || this.tp('error.mandatory'), isVisible: showCustomFieldError }));
        var containerClassNames = "custom-field-container";
        var titleComp = fieldData.title ? React.createElement("div", { className: 'cf-title' }, fieldData.title) : null;
        var descriptionComp = fieldData.description ? React.createElement("div", { className: 'cf-description' }, fieldData.description) : null;
        switch (customField.type) {
            case CustomFieldType.TEXT:
                var inputValue = fieldValue;
                return (React.createElement("label", { className: containerClassNames, "data-type": fieldType, "data-name": fieldName },
                    titleComp,
                    descriptionComp,
                    React.createElement("input", { type: 'text', value: inputValue, onChange: this.onTargetValueChange, placeholder: fieldData.placeHolder, "aria-invalid": showCustomFieldError }),
                    customFieldErrorMsg));
            case CustomFieldType.MULTILINE_TEXT:
                var textareaValue = fieldValue;
                return (React.createElement("label", { className: containerClassNames, "data-type": fieldType, "data-name": fieldName },
                    titleComp,
                    descriptionComp,
                    React.createElement("textarea", { "aria-invalid": showCustomFieldError, value: textareaValue, onChange: this.onTargetValueChange, placeholder: fieldData.placeHolder }),
                    customFieldErrorMsg));
            case CustomFieldType.BOOLEAN:
                var checkboxValue = fieldValue;
                var isChecked = !!checkboxValue ? 'checked' : '';
                var val = fieldValue;
                return (React.createElement("div", { className: containerClassNames, "data-type": fieldType, "data-name": fieldName },
                    titleComp,
                    descriptionComp,
                    React.createElement("label", { tabIndex: 0, ref: this.setCheckboxRef, className: "checkbox-label " + isChecked },
                        React.createElement(CheckboxIcon, null),
                        React.createElement("input", { type: 'checkbox', className: classNames('checkbox-item', fieldName, 'checkbox'), value: val, onChange: this.onCheckboxChange, "aria-label": 'checkbox', "aria-hidden": 'false', "aria-invalid": showCustomFieldError, checked: checkboxValue }),
                        React.createElement("span", null, fieldData.placeHolder)),
                    customFieldErrorMsg));
            case CustomFieldType.NUMBER: {
                var numberValue = fieldValue;
                var value = numberValue !== undefined ? numberValue : null;
                var placeholder = fieldData.placeHolder;
                return (React.createElement("div", { className: containerClassNames, "data-type": fieldType, "data-name": fieldName },
                    titleComp,
                    descriptionComp,
                    React.createElement(NumericInput, { value: value, onChange: this.onNumericChange, placeholder: placeholder }),
                    customFieldErrorMsg));
            }
            // TODO
            // case CustomFieldType.DATE:
            // TODO
            // case CustomFieldType.MULTI_SELECT
            case CustomFieldType.SINGLE_SELECT:
                var selectValue = fieldValue;
                var options = customField.data.values.map(function (value) { return ({ value: value, label: value }); });
                return (React.createElement("div", { className: containerClassNames, "data-type": fieldType, "data-name": fieldName },
                    titleComp,
                    descriptionComp,
                    React.createElement(DeprecatedSelect, { value: selectValue, onChange: this.onSelectChange, options: options, placeholder: fieldData.placeHolder, useSelectV3: false }),
                    customFieldErrorMsg));
            case CustomFieldType.MULTI_LEVEL:
                var texts = {
                    placeholder: this.tp('multilevel.placeholder'),
                    clearText: this.tp('multilevel.clear')
                };
                var onChange = function (data) {
                    props.onCustomFieldChange(props.customField.name, data.value);
                };
                var isMandatory = props.customField.mandatory || false;
                if (!isFeatureEnabled('MultilevelFieldsHelpcenter')) {
                    return null;
                }
                var validationError = props.validationError || this.tp('multilevel.mandatory');
                return (React.createElement("div", { className: "custom-field-container " + (!isMandatory ? 'not-mandatory' : ''), "data-value": fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.toString() },
                    React.createElement(PublicMultilevelField, { value: (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.toString()) || '', field: props.customField, validationError: props.showError ? validationError : '', texts: texts, mandatory: isMandatory, onChange: onChange, locale: props.locale })));
            default:
                return null;
        }
    };
    return CustomField;
}(React.Component));
export { CustomField };
//# sourceMappingURL=custom-field.js.map